import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

export default function CTABand({ line, buttonLabel = "Request a briefing" }) {
  return (
    <section data-testid="cta-band" className="bg-[#1F2D4E]">
      <div className="mx-auto flex max-w-6xl flex-col items-start gap-8 px-5 py-16 sm:px-8 sm:py-20 md:flex-row md:items-center md:justify-between">
        <Reveal>
          <p className="font-serif2 text-2xl font-semibold text-white sm:text-3xl">{line}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <Link
            to="/contact"
            data-testid="cta-band-button"
            className="inline-block bg-[#B08D3F] px-7 py-3.5 text-sm font-semibold uppercase tracking-[0.12em] text-white transition-colors hover:bg-[#96772f]"
          >
            {buttonLabel}
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
